"use client";

export const ACCOUNT_BLOCKED_CODE = "ACCOUNT_BLOCKED";
export const ACCOUNT_BLOCKED_MESSAGE =
  "Your account has been blocked due to a violation of the Terms of Use.";

type ErrorLike = {
  response?: {
    data?: unknown;
  };
};

function extractErrorPayload(error: unknown): Record<string, unknown> | null {
  if (
    typeof error === "object" &&
    error !== null &&
    "response" in error
  ) {
    const data = (error as ErrorLike).response?.data;
    if (typeof data === "object" && data !== null) {
      if ("detail" in data) {
        const detail = (data as { detail?: unknown }).detail;
        if (typeof detail === "object" && detail !== null) {
          return detail as Record<string, unknown>;
        }
      }
      return data as Record<string, unknown>;
    }
  }

  if (typeof error === "object" && error !== null) {
    return error as Record<string, unknown>;
  }

  return null;
}

export function isAccountBlockedError(error: unknown): boolean {
  const payload = extractErrorPayload(error);
  if (payload?.code === ACCOUNT_BLOCKED_CODE) {
    return true;
  }

  return (
    typeof payload?.detail === "string" &&
    payload.detail.includes(ACCOUNT_BLOCKED_MESSAGE)
  );
}

export function getBlockedMessageFromReason(reason: string | null): string | null {
  return reason === "blocked" ? ACCOUNT_BLOCKED_MESSAGE : null;
}
